// import ArgonBox from 'component/Argon/ArgonBox';
// import ArgonTypography from 'component/Argon/ArgonTypography';
import { forwardRef } from 'react';
import ArgonInput from 'component/Argon/ArgonInput';
import { Box, Typography } from '@mui/material';

const TextField = forwardRef((props, ref) => {
  const { label, dense, ml, error, ...rest } = props;
  return (
    <Box my={!!dense ? 0.5 : 2} ml={ml} lineHeight={0} display="block">
      {label && (
        <Box ml={0.5} mb={0.5}>
          <Typography component="label" variant="caption" fontWeight="bold">
            {label}
          </Typography>
        </Box>
      )}
      <ArgonInput ref={ref} error={!!error} {...rest} />
      {!!error?.message && (
        <Box ml={0.5}>
          <Typography component="label" color="red" variant="caption" fontWeight="bold">
            {`${error?.message}`}
          </Typography>
        </Box>
      )}
    </Box>
  );
});

export default TextField;
